import { CONTRACTOR_WO_PRIORITIES_CRUD_ACTION_CONSTANTS as CRUD_ACTION_CONSTANTS } from '../actions/contractor_wo_priorities_actions';
import { standardInitialStateGenerator, standardReducerGenerator } from './standard_reducer_utils';

const initialState: any = standardInitialStateGenerator([
	'WORK_ORDER_FORM_WORK_ORDER_PRIORITIES_AUTOCOMPLETE',
	'CONTRACTOR_WO_EDIT_AUTOCOMPLETE',
]);
export default standardReducerGenerator(CRUD_ACTION_CONSTANTS, initialState);
